module.exports = __webpack_public_path__ + "static/media/coforge.274fd0c7.png";